// extracted by mini-css-extract-plugin
export var actions = "_sn-4";
export var item = "_sn-1";
export var price = "_sn-3";
export var quantity = "_sn-2";
export var table = "_sn-0";